import './Contact.css'
import contactus from '../../imgs/contactus.png'

import Form from './Form'


const Contact = () => {
  return (
    <>
      <div className="contact container d-flex flex-column align-items-center">
        <h1 className='text-center '>CONTACT ME</h1>
        <div className='container justify-content-center row'>
          <div className='form col-lg-5'>
            <Form />
          </div>

          <div className='contact-info my-4 col-lg-6 d-flex justify-content-center align-items-center flex-column'>
            
              <img src={contactus} alt="contact us" className='img-fluid mt-5' style={{width: "500px"}}/>
          </div>
        </div>

      </div>
    </>
  )
}

export default Contact